import type { IconTextRowProps } from '@lemonade-hq/uniclient-chat';
import {
  fadeAnimation,
  Flex,
  Icon,
  spacing,
  Text,
  topAlignedIcon,
  topAlignedIconSmallText,
} from '@lemonade-hq/uniclient-theme';
import { motion } from 'motion/react';
import { forwardRef } from 'react';
import type { IconTextListProps } from '../IconTextList';

const TEXT_COLORS = {
  primary: '$textPrimary',
  secondary: '$textSecondary',
};

export const IconTextRow = forwardRef<HTMLDivElement, IconTextRowProps & Pick<IconTextListProps, 'size'>>(
  ({ text, size, icon = 'checkmark-solid', disabled = false, variant, textColorVariant = 'primary' }, ref) => {
    const isSmall = size === 'sm';
    const iconVariant = disabled ? 'disabledSecondary' : variant ?? 'brand';

    return (
      <Flex as={motion.div} {...fadeAnimation} alignItems="flex-start" gap={spacing.s08} ref={ref}>
        <Icon
          containerClassName={isSmall ? topAlignedIconSmallText : topAlignedIcon}
          name={icon}
          size="md"
          variant={iconVariant}
        />
        <Text
          color={disabled ? '$textDisabled' : TEXT_COLORS[textColorVariant]}
          type={isSmall ? 'bodySmall' : 'bodyMedium'}
        >
          {text}
        </Text>
      </Flex>
    );
  },
);
